import styled from 'styled-components';

// colors
import {darkGrey, red} from '@drivesally/sally-ui/lib/libs/colors';

const Status = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({error}) => (error ? red : darkGrey)};
`;

export default Status;
